export default {
  "home.heading.default": "hüppa kõnesse",
  "home.heading.loading": "Avan ruumi...",
  "home.heading.join": "valmis liituma?",
  "home.heading.joined": "oled sees",
  "home.heading.pending": "ootan hosti",
  "home.body.default": "tee ruum, viska link, tšilli.",
  "home.body.loading": "üks hetk, laen ruumi.",
  "home.body.join": "kontrolli kaamerat ja mikrit, siis hüppa sisse.",
  "home.body.joined": "ruum on laivis. jaga linki või hakka pihta.",
  "home.body.joined_in_room": "ruumis sees — hüppa kampa või jaga linki.",
  "home.body.pending": "ruum on lukus. host laseb su sisse.",
  "home.cta.create": "Loo ruum",
  "home.cta.join": "Liitu ruumiga",
  "home.cta.enter": "Sisene ruumi",
  "home.cta.creating": "Loon...",
  "home.cta.joining": "Liitun...",
  "home.cta.opening": "Avan...",
  "home.cta.pending": "Ootan luba...",
  "home.copy_link": "kopeeri link",
  "home.copied": "kopeeritud!",
  "home.leave": "lahku ruumist",
  "home.back": "tagasi",
  "home.no_participants": "kedagi pole veel siin",
  "home.join_by_code": "liitu koodiga",
  "home.code_placeholder": "sisesta kood",
  "home.name_placeholder": "sinu nimi",
  "home.people_one": "inimene",
  "home.people_other": "inimest",
  "home.marketing.invite.title": "Loo ruum,\njaga linki.",
  "home.marketing.invite.body": "Üks vajutus ja valmis. Jaga linki sõpradega ja kõik saavad liituda — ei mingeid allalaadimisi ega kontosid.",
  "home.marketing.invite.preview_url": "yano.ai/RUUM",
  "home.marketing.look.title": "Näe välja\nnii nagu tahad.",
  "home.marketing.look.body": "Värvid, pehmendus, vinjett — või bluri nägu täiesti ära. Sinu kaamera, sinu välimus.",
  "home.marketing.host.title": "Sinu ruum,\nsinu reeglid.",
  "home.marketing.host.body": "Pane ruum lukku, vaigista kedagi või viska nad üldse välja. Hostil on kontroll.",
  "home.marketing.host.locked": "Ruum lukus",
  "home.marketing.host.waiting_to_join": "Ootab liitumist",
  "home.marketing.host.wants_to_join": "tahab liituda",
  "home.marketing.anything.title": "Päriselt, milleks iganes.",
  "home.marketing.anything.body": "Õppimiseks, mänguõhtuteks, töö standupideks, koos vaatamiseks — või lihtsalt tšillimiseks.",
  "home.marketing.use_case.study_group": "📚 õppegrupp",
  "home.marketing.use_case.game_night": "🎮 mänguõhtu",
  "home.marketing.use_case.standup": "💼 standup",
  "home.marketing.use_case.watch_party": "🍿 watch party",
  "home.marketing.use_case.catch_up": "☕ jutuajamine",
  "home.marketing.use_case.jam_session": "🎸 jämm",
  "home.marketing.use_case.book_club": "📖 raamatuklubi",
  "home.marketing.use_case.coworking": "💻 co-working",
  "ended.heading": "kõne läbi",
  "ended.left": "sa lahkusid ruumist.",
  "ended.room_ended": "{title} on sinu jaoks läbi.",
  "ended.rejoin": "liitu uuesti",
  "ended.rejoining": "liitun uuesti...",
  "ended.home": "tagasi avalehele",
  "call.connecting": "ühendan",
  "call.waiting": "ootan teisi",
  "call.invite_code": "kutsekood",
  "call.audio_on": "heli sees",
  "call.muted": "vaigistatud",
  "call.listening": "Kuulab",
  "call.audio_muted": "Heli vaigistatud",
  "call.speaking": "räägib",
  "call.you": "sina",
  "call.you_label": "Sina",
  "call.you_suffix": "(sina)",
  "call.chat_placeholder": "saada sõnum...",
  "call.guest": "külaline",
  "call.room_fallback": "ruum",
  "call.focus_view": "Fookusvaade",
  "call.grid_view": "Ruudustik",
  "call.swap_main_video": "Vaheta peamist videot",
  "call.open_chat": "Ava chat",
  "call.close_chat": "Sulge chat",
  "call.leave_room": "Lahku ruumist",
  "call.confirm_leave": "Lahkud?",
  "call.mic_on": "Mikrofon sees",
  "call.muted_label": "Vaigistatud",
  "call.camera_off": "Kaamera väljas",
  "call.connect_failed": "Ühendus ebaõnnestus — kontrolli netti ja proovi uuesti.",
  "call.camera_access_failed": "Ei saanud kaamerale ligi. Vaata brauseri õigused üle ja proovi uuesti.",
  "call.recording_failed": "Salvestamine ei alanud. Kõne jätkub ilma selleta.",
  "call.initialize_failed": "Kõne alustamisel läks midagi nihu. Värskenda lehte ja proovi uuesti.",
  "call.participants": "Osalejad",
  "call.open_participants": "Ava osalejad",
  "call.close_participants": "Sulge osalejad",
  "call.lock_room": "Pane ruum lukku",
  "call.unlock_room": "Tee ruum lahti",
  "call.locked": "lukus",
  "call.unlocked": "avatud",
  "call.kick_member": "Eemalda ruumist",
  "call.mute_member": "Vaigista",
  "call.unmute_member": "Võta vaigistus maha",
  "call.muted_by_host": "Hosti poolt vaigistatud",
  "call.waiting_to_join": "Ootab liitumist",
  "call.approve": "Luba sisse",
  "call.deny": "Keeldu",
  "call.profile_actions": "Profiili tegevused",
  "call.profile_in_room": "Ruumis",
  "call.profile_role_host": "Host",
  "call.profile_role_you": "Sina",
  "call.profile_action_mute": "Vaigista nende heli",
  "call.profile_action_mute_meta": "Ainult sinu jaoks — nad ei saa teada",
  "call.profile_action_dm": "1:1 DM",
  "call.profile_action_dm_meta": "Alusta privaatset vestlust",
  "call.profile_action_view": "Vaata kogu profiili",
  "call.profile_action_view_meta": "Bio, keeled, varasemad sessioonid",
  "call.profile_action_report": "Raporteeri",
  "call.profile_action_report_meta": "Märgi modereerimiseks",
  "call.profile_sheet_close": "Sulge profiili tegevused",
  "call.profile_open_actions": "Ava profiili tegevused",
  "call.dm_title": "Privaatsõnum",
  "call.dm_back": "Tagasi tegevuste juurde",
  "call.dm_close": "Sulge privaatsõnum",
  "call.dm_status_online": "Online",
  "call.dm_in_room_with": "Selles ruumis",
  "call.dm_private_label": "Privaatne chat",
  "call.dm_private_meta": "Ainult teie kaks näete neid sõnumeid",
  "call.dm_input_placeholder": "Saada privaatsõnum…",
  "call.dm_send": "Saada",
  "call.dm_just_now": "praegu",
  "call.dm_seen_just_now": "Nähtud just praegu",
  "call.dm_typing": "{name} kirjutab…",
  "call.dm_minimize": "Minimeeri",
  "call.dm_active_indicator": "Ava vestlus",
  "call.dm_unread_messages": "{count} lugemata",
  "call.dm_toast_tap_to_open": "Vajuta, et avada",
  "call.dm_reopen_aria": "Ava uuesti vestlus kasutajaga {name}",
  "home.join_denied": "Host ei lasknud sind sisse.",
  "home.error.room_not_found": "Sellist ruumikoodi pole olemas.",
  "home.error.profile_required": "Jätkamiseks pane oma profiil paika.",
  "home.cta.set_up_profile": "Seadista oma profiil",
  "home.profile_trigger_new": "Vajuta, et lisada oma info",
  "home.profile_trigger_new_aria": "Seadista oma profiil",
  "home.profile_trigger_edit_aria": "Muuda oma profiili",
  "profile.eyebrow_new": "ütle tsau",
  "profile.eyebrow_edit": "sinu profiil",
  "profile.title_new": "Tee see enda omaks.",
  "profile.title_edit": "Muuda profiili",
  "profile.subtitle": "Paar kiiret detaili, et teised teaks, kellega nad kohtuvad.",
  "profile.add_photo": "Lisa pilt",
  "profile.add_photo_soon": "pildid tulevad varsti",
  "profile.photo_empty": "vajuta, et lisada pilt",
  "profile.photo_ready": "pilt valmis",
  "profile.photo_save_first": "salvesta profiil enne pildi üleslaadimist",
  "profile.photo_crop_caption": "kadreeri oma pilt",
  "profile.photo_auto_caption": "lohista ja suumi, salvestame automaatselt",
  "profile.photo_upload": "Lae pilt üles",
  "profile.photo_replace": "Vaheta pilti",
  "profile.photo_remove": "Eemalda pilt",
  "profile.photo_cancel": "Tühista",
  "profile.photo_save": "Salvesta pilt",
  "profile.photo_uploading": "Laen pilti üles…",
  "profile.photo_removing": "Eemaldan pilti…",
  "profile.photo_choose_another": "Vali teine",
  "profile.photo_drag_hint": "Lohista pilt ringi sisse. Muudatused salvestuvad automaatselt.",
  "profile.photo_zoom": "Suumi",
  "profile.photo_horizontal": "Horisontaalne lõige",
  "profile.photo_vertical": "Vertikaalne lõige",
  "profile.name_label": "Nimi",
  "profile.name_placeholder": "Kuidas me sind kutsume?",
  "profile.gender_label": "Ma olen",
  "profile.gender.woman": "Naine",
  "profile.gender.man": "Mees",
  "profile.gender.unspecified": "Eelistan mitte öelda",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "valikuline",
  "profile.bio_placeholder": "Keeled, mida räägid, mis sulle meeldib, mida iganes…",
  "profile.cta_new": "Lähme",
  "profile.cta_edit": "Salvesta muudatused",
  "profile.saving": "Salvestan…",
  "profile.close": "Sulge",
  "profile.error.save_failed": "Ei saanud profiili salvestada. Proovi uuesti.",
  "profile.error.avatar_invalid_type": "Vali PNG, JPEG, GIF või WebP pilt.",
  "profile.error.avatar_too_large": "Vali pilt, mis on väiksem kui 5 MB.",
  "profile.error.avatar_too_small": "Vali pilt, mis on vähemalt 96x96 pikslit.",
  "profile.error.avatar_load_failed": "Me ei suutnud seda pilti lugeda. Proovi teist faili.",
  "profile.error.avatar_failed": "Ei saanud pilti üles laadida. Proovi uuesti.",
  "profile.error.avatar_remove_failed": "Ei saanud pilti eemaldada. Proovi uuesti.",
  "effects.title": "Efektid",
  "effects.soft": "Pehme fookus",
  "effects.vignette": "Vinjett",
  "effects.face": "Näo blur",
  "effects.face_preview_only": "Näo blur (ainult eelvaade)",
  "effects.face_viewer_side": "Näo blur (vaataja poolt)",
  "effects.face_strength": "Näo bluri tugevus",
  "effects.grade.off": "VÄLJAS",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "SOE",
  "effects.grade.cool": "KÜLM",
  "effects.grade.bw": "M&V",
  "camera.off": "kaamera on väljas",
  "camera.check": "kontrolli kaamerat",
  "camera.retry": "proovi kaamerat uuesti",
  "camera.ready": "kaamera valmis",
  "camera.idle.title": "Pane kaamera tööle",
  "camera.idle.hint": "Küsime brauserilt luba, kui oled valmis.",
  "camera.idle.button": "Pane kaamera tööle",
  "camera.status.idle": "Ootan sind",
  "camera.status.off": "Kaamera on väljas",
  "camera.status.loading": "Küsin kaamerale ligipääsu...",
  "camera.status.denied": "Luba brauseris kaamerale ligipääs ja proovi uuesti.",
  "camera.status.error": "Kaamera eelvaade ebaõnnestus. Proovi uuesti.",
  "camera.status.unsupported": "See brauser ei toeta kaamerat.",
  "camera.status.insecure": "Kaamera vajab HTTPS-i või localhosti.",
  "camera.status.attach_failed": "Kaamera eelvaadet ei saanud käivitada. Proovi uuesti.",
  "camera.guest_name_placeholder": "Külalise nimi",
  "camera.flip": "Vaheta kaamerat",
  "camera.save_name": "Salvesta",
  "camera.edit_name": "Muuda nime",
  "mic.on": "Lülita mikker välja",
  "mic.off": "Lülita mikker sisse",
  "video.on": "Lülita kaamera välja",
  "video.off": "Lülita kaamera sisse",
  "chat.title": "chat",
  "chat.close": "Sulge chat",
  "chat.loading": "laen...",
  "chat.load_earlier": "lae varasemad",
  "chat.empty": "sõnumeid veel pole",
  "chat.send_error": "Sõnum ei läinud teele — proovi uuesti.",
  "chat.input_placeholder": "kirjuta sõnum...",
  "room.host": "Host",
  "app.room_default_title": "Loo ruum",
  "app.chat_connection_rejected": "Chat ei ühendunud — proovi lehte värskendada.",
  "app.copy_failed": "Lingi kopeerimine ebaõnnestus. Proovi see ise märkida ja kopeerida.",
  "app.chat_not_connected": "Chat pole veel ühendatud. Oota hetk ja proovi uuesti.",
  "footer.terms": "Kasutustingimused",
  "footer.copyright": "© 2026 Yano.AI"
}
